"use client";
import React, { useState, useEffect } from "react";
import { get_ir_report_and_prospect_from_site } from "@/spotlight/client";
import Title from "@/library/sections/texts/Title";
import { storyblokEditable } from "@storyblok/react";
import SpotlightReportAndProspectPagination from "@/library/components/paginations.jsx/SpotlightReportAndProspectPagination";

export default function SpotlightReportAndProspectBlock({ blok }) {
  const { numberOfItems, title, titleAs, titleColor } = blok;
  const [reportAndProspectList, setReportAndProspectList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const func = async () => {
      const reportAndProspectList_ = await get_ir_report_and_prospect_from_site(
        {}
      );
      setReportAndProspectList(reportAndProspectList_);
      setIsLoading(false);
    };
    func();
  }, [numberOfItems]);

  return (
    <section
      {...storyblokEditable(blok)}
      className="container max-w-5xl mx-auto p-12"
    >
      <Title
        title={title}
        titleColor={titleColor}
        titleAs={titleAs}
        className={"font-bold mb-20 "}
      />

      {isLoading && <div className="text-center mt-36 mb-64">Loading...</div>}

      {!isLoading && (
        <SpotlightReportAndProspectPagination
          wrapperClassName="grid grid-cols-1 gap-6"
          items={reportAndProspectList}
          itemsPerPage={parseInt(numberOfItems)}
        />
      )}
    </section>
  );
}
